/**
 * A vehicle is "active" when the current moment falls inside its service window
 * (firstDate–lastDate). The shared `vehicle_list` proc returns every non-deleted
 * vehicle — including retired ones (lastDate in the past) which stay around for
 * historical keikkas — so the active filter is applied client-side.
 *
 * Mirrors puminet4's canonical definition in VehicleFunctions.jsx (vehicle_fetchList):
 *   active = (firstDate == null || firstDate <= now) && (lastDate == null || lastDate >= now)
 *
 * Note: this compares against the raw `lastDate` (UTC midnight), so a vehicle
 * retired with lastDate=today drops out of the active list immediately — retiring
 * is an explicit "remove now" action. This is deliberately NOT the end-of-day rule
 * SijainnitTab uses for passive jerryActiveUntil expiry (which keeps a row visible
 * through its whole final local day).
 *
 * @param {{ firstDate?: string|Date|null, lastDate?: string|Date|null }} v
 * @param {number} [now] epoch ms; injectable for tests
 * @returns {boolean}
 */
export function isVehicleActive(v, now = Date.now()) {
  const first = v?.firstDate ? new Date(v.firstDate).getTime() : null;
  const last = v?.lastDate ? new Date(v.lastDate).getTime() : null;
  return (first == null || first <= now) && (last == null || last >= now);
}
